// Typing boxes with suggestions (CustomSelect `suggestionsOnly`, QA batch 15).

/** What a key does in a suggestionsOnly box . */
export const suggestionKeyAction = (
  key: string,
  movedToOption: boolean,
): "default" | "type-space" | "ignore" | "show-first" => {
  if (key === " ") return "type-space";
  if (movedToOption) return "default";
  if (key === "Enter") return "ignore";
  // The first option is already focused inside react-select: the first arrow
  // press only makes it visible instead of skipping to the second one.
  if (key === "ArrowDown") return "show-first";
  return "default";
};

export const insertAt = (
  text: string,
  start: number,
  end: number,
  insert: string,
) => text.slice(0, start) + insert + text.slice(Math.max(start, end));
